import { Component } from '@angular/core';
import { ScrEnvironment } from 'src/environments/environment';
import { ScrBaseComponent } from '../base.component';
import { ConfigService } from 'src/app/services';
import { first } from 'rxjs';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent extends ScrBaseComponent {
  public year: number = new Date().getFullYear();
  constructor(private configService: ConfigService, private environment: ScrEnvironment) { 
    super();

    // update it using the config.
    this.configService.getConfig().pipe(first()).subscribe(cfg => {
      this.links.RegSubLicenseAgreement = cfg.licenseAgreement.content;
    });

   }
  public baseUrl = this.environment.mbbase;
  public links = {
    AcceptableUsePolicy: `${this.baseUrl}/acceptable-use-policy`,
    PrivacyPolicy: `${this.baseUrl}/privacy-policy`,
    RegSubLicenseAgreement: `${this.baseUrl}/sublicense-agreement`,
    TermsOfUse: `${this.baseUrl}/website-terms-use`,
    CTIAImage: `https://www.ctia.org/`,
    IconectivImage: `https://iconectiv.com/`,
  };

}
